/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_Show_FullInputs */

const cs_ebr_diff_show_full = /** @type {(inputs: Ebr_Diff_Show_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit celý text`)
};

const en_ebr_diff_show_full = /** @type {(inputs: Ebr_Diff_Show_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show full text`)
};

/**
* | output |
* | --- |
* | "Show full text" |
*
* @param {Ebr_Diff_Show_FullInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_show_full = /** @type {((inputs?: Ebr_Diff_Show_FullInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Show_FullInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_show_full(inputs)
	return cs_ebr_diff_show_full(inputs)
});